import { useSection } from "@/lib/SiteContent";

export const Footer = () => {
  const footer = useSection("footer", { message: "" });
  return (
    <footer data-testid="footer" className="bg-[#F3F5E7] border-t border-[#68919B]/30 py-16 px-6">
      <div className="max-w-5xl mx-auto text-center">
        <p className="text-xs uppercase tracking-[0.35em] text-[#68919B] mb-6">15. august</p>
        <h3 className="font-serif text-4xl md:text-5xl text-[#3D5E68] font-light">
          Celine
          <span className="font-script text-5xl md:text-6xl text-[#68919B] mx-3">&amp;</span>
          Aleksander
        </h3>
        <div className="flex items-center justify-center mt-8 mb-8">
          <span className="ornament" />
        </div>
        <p className="text-sm text-[#5A7682] font-light">Spjærøy · Hvaler</p>
        <p className="text-xs text-[#68919B] font-light mt-8 tracking-wide">{footer.message}</p>
      </div>
    </footer>
  );
};
